import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ko from './locales/ko.json'

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en, ko },
    fallbackLng: 'en',
    detection: {
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === 'development',
  })

if (i18next.resolvedLanguage) {
  document.documentElement.lang = i18next.resolvedLanguage
  dayjs.locale(i18next.resolvedLanguage)
}
